import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const TruckIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>truck_icon</title>
    <path d="M44,29H43L40,13H32V9H4V33H9.1a5,5,0,1,0,9.8,0H30.1a5,5,0,1,0,9.8,0H44V29ZM12,27H8V13h4V27Zm8,0H16V13h4V27Zm8,0H24V13h4V27Zm4,0V17h4.75l1.88,10H32Z" />
  </IconBase>
);
